import { render, staticRenderFns } from "./CriterionSectionEditor.vue?vue&type=template&id=abfcd9cc"
import script from "./CriterionSectionEditor.vue?vue&type=script&lang=ts"
export * from "./CriterionSectionEditor.vue?vue&type=script&lang=ts"
import style0 from "./CriterionSectionEditor.vue?vue&type=style&index=0&id=abfcd9cc&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports